import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";
import Loading from "../../components/Loading/Loading";

const API_URL = process.env.REACT_APP_API_URL;

const Callback = () => {
	const { login: authLogin } = useAuth();
	const navigate = useNavigate();

	useEffect(() => {
		const handleKeycloakCallback = async () => {
			const params = new URLSearchParams(window.location.search);
			const code = params.get("code");
			const error = params.get("error");

			if (error) {
				console.error("Keycloak authentication failed:", error);
				navigate("/login");
				return;
			}

			if (!code) {
				console.error("No authorization code received");
				navigate("/login");
				return;
			}			

			try {
				const response = await fetch(
					`${API_URL}/accounts/auth/keycloak/`,
					{
						method: "POST",
						headers: {
							"Content-Type": "application/json",
						},
						body: JSON.stringify({ code }),
					}
				);

				if (response.ok) {
					const data = await response.json();
					authLogin(data);
					const isAdmin = data.is_admin;

					localStorage.setItem("show_modal", "true");
					isAdmin
						? navigate("/admin/dashboard")
						: navigate("/user/dashboard");
				} else {
					throw new Error("Failed to exchange code for tokens");
				}
			} catch (err) {
				console.error("Error during Keycloak callback:", err);
				navigate("/login");
			}
		};

		handleKeycloakCallback();
	}, [authLogin, navigate]);

	return <Loading></Loading>;
};

export default Callback;
